export default "__VITE_ASSET__BZTLRJSX__"